import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/theme.scss'
import 'node-waves/dist/waves.min.css'
import 'simplebar/dist/simplebar.min.css'
import 'flatpickr/dist/flatpickr.min.css'
import 'choices.js/public/assets/styles/choices.css'

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import * as Waves from 'node-waves'

import { App } from './App.tsx'

// Registers one delegated body-level ripple listener for every current and
// future `.waves-effect` element — a single global call, not per-component.
Waves.init()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
